module.exports = __webpack_public_path__ + "img/money.5bc47b75.svg";